import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import router from 'router/router.container';
import './App.css';
import 'typeface-muli';
import 'typeface-roboto';
import '../i18n/i18n';
import FullPageLoader from 'components/Loader/components/FullpageLoader';
import { useInitializeAppServicesAndValues } from './App.hooks';

function App() {
  const { isLoading } = useInitializeAppServicesAndValues();

  if (isLoading) {
    return <FullPageLoader />;
  }

  return (
    <Suspense fallback={<FullPageLoader />}>
      <RouterProvider router={router} />
    </Suspense>
  );
}

export default App;
